import { createSlice } from "@reduxjs/toolkit";
import { IInputBox } from "pages/OrderModal/components/DstAddress/types";
import { initialBox } from "pages/OrderModal/components/DstAddress/constants";
import { IRoute } from "store/api/types";

interface IDstAddress {
  boxes: IInputBox[];
  noRoutes: boolean;
}

const initialState: IDstAddress = {
  boxes: [initialBox],
  noRoutes: false,
};

const dstAddressSlice = createSlice({
  name: "dstAddress",
  initialState,
  reducers: {
    setFoundPlaces(state, { payload }) {
      const { currentInput, foundPlaces } = payload;
      state.boxes = state.boxes.map((box, index) =>
        index === currentInput ? { ...box, foundPlaces } : box,
      );
    },
    clearFoundPlaces(state, { payload }) {
      const { currentInput } = payload;
      state.boxes = state.boxes.map((box, index) =>
        index === currentInput ? { ...box, foundPlaces: [] } : box,
      );
    },
    setAddress(state, { payload }) {
      const { currentInput, address, foundBuildings, lat, lng } = payload;
      state.boxes = state.boxes.map((box, index) =>
        index === currentInput
          ? { ...box, address, foundBuildings, lat, lng }
          : box,
      );
    },
    clearAddress(state, { payload }) {
      const { currentInput } = payload;
      state.boxes = state.boxes.map((box, index) =>
        index === currentInput
          ? { ...box, address: "", foundBuildings: [], lat: 0, lng: 0 }
          : box,
      );
    },
    setBuilding(state, { payload }) {
      const { currentInput, building, lat, lng } = payload;
      state.boxes = state.boxes.map((box) =>
        box.order === currentInput + 1 ? { ...box, building, lat, lng } : box,
      );
    },
    clearBuilding(state, { payload }) {
      const { currentInput } = payload;
      state.boxes = state.boxes.map((box) =>
        box.order === currentInput + 1
          ? { ...box, building: "", lat: 0, lng: 0 }
          : box,
      );
    },
    addBox(state, { payload }) {
      state.boxes.push(payload);
    },
    removeBox(state, { payload }) {
      state.boxes = state.boxes
        .filter((box) => box.id !== payload.id)
        .sort((a, b) => a.order - b.order)
        .map((box, index) => ({ ...box, order: index + 1 }));
    },
    reorderBoxes(state, { payload }) {
      const { currentBox, box } = payload;
      state.boxes = state.boxes.map((b) => {
        if (b.id === box.id) {
          return { ...b, order: currentBox.order };
        }
        if (b.id === currentBox.id) {
          return { ...b, order: box.order };
        }
        return b;
      });
      state.boxes.sort((a, b) => a.order - b.order);
    },
    setNoRoutes(state, { payload }) {
      state.noRoutes = payload;
    },
    setBoxes(state, { payload }) {
      state.boxes = payload.map((boxData: IRoute, index: number) => ({
        id: index + 1,
        order: index + 1,
        address: boxData.name,
        building: boxData.number,
        foundPlaces: [],
        foundBuildings: [],
        lat: boxData.lat,
        lng: boxData.lng,
      }));
    },
    clearBoxes(state) {
      state.boxes = [initialBox];
    },
  },
});

export const {
  setFoundPlaces,
  clearFoundPlaces,
  setAddress,
  clearAddress,
  setBuilding,
  clearBuilding,
  addBox,
  removeBox,
  reorderBoxes,
  setNoRoutes,
  setBoxes,
  clearBoxes,
} = dstAddressSlice.actions;
export default dstAddressSlice.reducer;
